/* Stay on budget: the Dogs / Cats tabs in sections/budget-picks.liquid.
   Click or arrow keys switch tabs. In the theme editor, selecting a group or a
   tile block opens the tab it belongs to. Mode "tabs" hides inactive panels with
   the hidden attribute; mode "hybrid" only moves the is-active class, and the
   stylesheet hides inactive panels on phones only. */
if (!customElements.get('budget-tabs')) {
  class BudgetTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (this.tabs.length < 2) return;

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, i));
      });

      this.onBlockSelect = (event) => {
        if (!this.contains(event.target)) return;
        const tabIndex = this.tabs.indexOf(event.target);
        const panelIndex = this.panels.indexOf(event.target.closest('[role="tabpanel"]'));
        const index = tabIndex > -1 ? tabIndex : panelIndex;
        if (index > -1) this.select(index, { animate: false });
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    select(index, { focus = false, animate = true } = {}) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        tab.classList.toggle('is-active', active);
      });
      const hybrid = this.dataset.mode === 'hybrid';
      this.panels.forEach((panel, i) => {
        const wasHidden = hybrid ? !panel.classList.contains('is-active') : panel.hidden;
        panel.classList.toggle('is-active', i === index);
        if (!hybrid) panel.hidden = i !== index;
        if (i === index && wasHidden) {
          const row = panel.querySelector('.sb-grid');
          if (row) row.scrollLeft = 0;
          if (animate) {
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          }
        }
      });
      if (focus) this.tabs[index].focus();
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      this.select(next, { focus: true });
    }
  }
  customElements.define('budget-tabs', BudgetTabs);
}
